<template>

  <span class="app-bar__language-switcher--content">
    <v-select class="app-bar__language-switcher--switch" @change="switchLanguage()"
      v-model="$i18n.locale" 
      :items="$i18n.availableLocales"
      :menu-props="{ offsetY: true }"
      append-icon="mdi-chevron-down"
      hide-details
      >
        <template slot="item" slot-scope="data">
          <span style="text-transform: capitalize;">{{data.item}}</span>
        </template>
      </v-select>
  </span>

</template>

<script>

import { mapState } from "vuex";

export default {
 
  computed: {
    ...mapState(['user'])
  },
  methods: {
    switchLanguage() {
        this.$store.dispatch('setLocale', this.$i18n.locale)
    }
  },
    
}
</script>
